import React from "react";
import { FiCheck, FiCopy } from "react-icons/fi";
import { getDashboardSummariserApis, buildApiCopyBlock } from "../data/munshotDataApis";
import MunshotApiCard, { useCopy } from "./MunshotApiCard";
import { h2Style, introStyle } from "./dashboardSkillGuideCommon";

const sectionStyle = {
  marginTop: "40px",
  paddingTop: "32px",
  borderTop: "1px solid #e2e8f0",
};

const copyAllButtonStyle = {
  display: "inline-flex",
  alignItems: "center",
  gap: "8px",
  height: "40px",
  padding: "0 14px",
  borderRadius: "6px",
  border: "1px solid #3730a3",
  backgroundColor: "#3730a3",
  color: "#ffffff",
  fontWeight: 600,
  fontSize: "13px",
  cursor: "pointer",
  marginBottom: "20px",
};

const DashboardSummariserApiDocs = () => {
  const apis = getDashboardSummariserApis();
  const { copiedKey, copyText } = useCopy();
  const allDocs = apis.map((api) => buildApiCopyBlock(api)).join("\n---\n\n");

  return (
    <section style={sectionStyle} aria-labelledby="dashboard-summariser-api-docs-heading">
      <h3 id="dashboard-summariser-api-docs-heading" style={h2Style}>
        API reference
      </h3>
      <p style={{ ...introStyle, marginBottom: "16px" }}>
        Endpoints used by Dashboard Summariser. Each block includes request fields, payload examples,
        response examples, and copyable cURL.
      </p>

      <button
        type="button"
        style={copyAllButtonStyle}
        onClick={() => copyText("all", allDocs)}
        aria-label="Copy all Dashboard Summariser API docs"
      >
        {copiedKey === "all" ? <FiCheck aria-hidden="true" /> : <FiCopy aria-hidden="true" />}
        {copiedKey === "all" ? "Copied all endpoints" : "Copy all endpoints"}
      </button>

      {apis.map((api) => (
        <MunshotApiCard key={api.id} api={api} copiedKey={copiedKey} copyText={copyText} />
      ))}
    </section>
  );
};

export default DashboardSummariserApiDocs;
